import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { Component } from 'react';
import _ from 'lodash';
import { HttpClient } from '@wix/http-client';
import { ProFullscreen, FULLSCREEN_EVENTS, VIEW_MODE } from '@wix/pro-fullscreen-renderer';
import withArtStore from '@wix/pro-gallery-artstore-statics/dist/src/withArtStore';
import cartApi from '@wix/pro-gallery-artstore-statics/dist/src/cartApi';
import { ARTSTORE_PUBSUB_ENUMS } from '@wix/pro-gallery-artstore-statics/dist/src/applications/consts';
import storeApi from '@wix/pro-gallery-artstore-statics/dist/src/storeApi';
import { ItemActions, Wix, parseStyleParams as _parseStyleParams, watermarkApi, getResizeMediaUrl, logger, experimentsWrapper } from '@wix/photography-client-lib';
import '../styles/fullscreen.global.scss';
import { GalleryItem } from '@wix/pro-layouts-old';
import { utils } from '../utils/utils';
import * as fedopsLogger from '@wix/fedops-logger';
var httpClient = new HttpClient();
var ProFullscreenTPAWrapper = /*#__PURE__*/function (_Component) {
  function ProFullscreenTPAWrapper(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.resize = _this.resize.bind(_this);
    _this.orientationChange = _this.orientationChange.bind(_this);
    _this.closeFullscreen = _this.closeFullscreen.bind(_this);
    _this.initCart = _this.initCart.bind(_this);
    _this.refreshCartItems = _this.refreshCartItems.bind(_this);
    _this.handleFullscreenEvent = _this.handleFullscreenEvent.bind(_this);
    _this.onLoveCountsFetched = _this.onLoveCountsFetched.bind(_this);
    _this.styleParams = _this.parseStyleParams({});
    _this.navigatedInto = false;
    _this.extraImages = utils.isMobile() ? 2 : 5; // number of images to preload on each side of the fullscre

    _this.itemActions = new ItemActions();
    _this.initGalleryInfo();
    _this.state = _this.prepareInitialState();
    window.isWebpSupported = utils.isWebpSupported();
    _this.shouldUseNewSocialSharePopup = true;
    _this.setFullscreenElement();
    return _this;
  }

  // ----------------------------------------| REACT |----------------------------------------//
  _inheritsLoose(ProFullscreenTPAWrapper, _Component);
  var _proto = ProFullscreenTPAWrapper.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.initNavigationEvents();
    this.init();
  };
  _proto.componentWillReceiveProps = function componentWillReceiveProps() {
    this.init();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearEvents();
  }

  // -----------------------------------------| INIT |----------------------------------------//
  ;
  _proto.init = function init() {
    if (this.isPreload()) {
      return;
    }
    if (utils.isVerbose()) {
      console.log('FULLSCREEN - init');
    }
    this.isOpen = true;
    this.initEvents();
    this.initGalleryInfo();
    this.resize(); // set initial size

    this.replaceCurrentUrl(this.state.initialIdx, this.state.items[this.state.initialIdx]); // set initial item
    // var isIE = utils.browserIs('explorer');
    // if (!isIE) {
    // this.cancelOpenHttpRequests(); //removed because it is causeing the fullscreen to be flaky
    // }

    utils.setStateAndLog(this, 'init', this.prepareInitialState());
    this.initStyleParams();
    this.initWatermark();
  };
  _proto.initStyleParams = function initStyleParams() {
    this.styleParams = this.parseStyleParams({}); // set defaults (sync)
    this.getStyleParams(); // get real params (async)
  };
  _proto.onLoveCountsFetched = function onLoveCountsFetched(photoId2Love) {
    var _this2 = this;
    var itemsLoveData = {};
    Object.entries(photoId2Love).forEach(function (_ref) {
      var id = _ref[0],
        loveCount = _ref[1];
      itemsLoveData[id] = {
        loveCount: loveCount,
        isLoved: _this2.itemActions.isLoved(id)
      };
    });
    this.setState({
      itemsLoveData: itemsLoveData
    });
  };
  _proto.refreshCartItems = function refreshCartItems(connectedProviders) {
    var _this3 = this;
    var connectedProviderId = Object.keys(connectedProviders)[0];
    cartApi.getCartItems(connectedProviderId).then(function (arrItems) {
      var cartItemsCount = cartApi.getCartItemsCount(arrItems);
      _this3.setState({
        cartItems: arrItems,
        cartItemsCount: cartItemsCount
      });
    });
  };
  _proto.addToCart = function addToCart(data) {
    var uuid = data.uuid,
      itemUrl = data.itemUrl,
      galleryId = data.galleryId,
      providerId = data.providerId,
      quantity = data.quantity,
      isDemo = data.isDemo,
      metadata = data.metadata,
      styleId = data.styleId;
    cartApi.addToCart(uuid, itemUrl, galleryId, providerId, quantity, isDemo, metadata, styleId).then(function (newItem) {
      cartApi.showCart();
      cartApi.updateItemsValidation([newItem]);
    });
  };
  _proto.initCart = function initCart() {
    var _this4 = this;
    cartApi.createCartForm();
    if (Wix && Wix.PubSub) {
      Wix.PubSub.subscribe(ARTSTORE_PUBSUB_ENUMS.REFRESH_CART, function () {
        var galleryInfo = _this4.galleryInfo;
        if (galleryInfo && galleryInfo.connectedProviders) {
          _this4.refreshCartItems(galleryInfo.connectedProviders);
        }
      }, true);
    }
  };
  _proto.getStoreApi = function getStoreApi() {
    var _this5 = this;
    return {
      initCart: function initCart(_connectedProviders) {
        return _this5.initCart();
      },
      refreshCartItems: function refreshCartItems(connectedProviders) {
        return _this5.refreshCartItems(connectedProviders);
      },
      showCart: function showCart() {
        return cartApi.showCart();
      },
      onCheckout: function onCheckout() {
        return Wix.PubSub.publish(ARTSTORE_PUBSUB_ENUMS.CHECKOUT, {}, false);
      },
      addToCart: function addToCart(data) {
        return _this5.addToCart(data);
      },
      openProviderModal: function openProviderModal(data) {
        var name = data.name,
          connectedProviders = data.connectedProviders,
          options = data.options,
          containerParams = data.containerParams;
        storeApi.openProviderModal(name, connectedProviders, options, containerParams);
      },
      updateCartItem: function updateCartItem(data) {
        return cartApi.updateCartItem(data.uuid, data.metadata, data.quantity);
      },
      clearCart: function clearCart() {
        return cartApi.clearCart();
      },
      removeFromCart: function removeFromCart(data) {
        return cartApi.removeFromCart(data.uuid);
      }
    };
  };
  _proto.setFullscreenElement = function setFullscreenElement() {
    var wixSdk = Wix;
    try {
      if (utils.isInSettings()) {
        wixSdk = window.parent.Wix;
      }
    } catch (error) {}
    this.fullscreenElement = utils.isStoreGallery() ? withArtStore({
      galleryInfo: this.galleryInfo,
      viewMode: this.state.viewMode,
      wixSdk: wixSdk,
      storeApi: this.getStoreApi(),
      appInstance: window.instance
    })(ProFullscreen) : ProFullscreen;
  };
  _proto.initFullscreenElementIfNeeded = function initFullscreenElementIfNeeded() {
    var shouldCreateFullscreenElement = false;
    if (!this.galleryInfo) {
      shouldCreateFullscreenElement = false;
    } else if (!this.prevGalleryInfo) {
      shouldCreateFullscreenElement = true;
    } else if (this.prevGalleryInfo.galleryId !== this.galleryInfo.galleryId) {
      shouldCreateFullscreenElement = true;
    }
    if (shouldCreateFullscreenElement) {
      this.prevGalleryInfo = {
        galleryId: this.galleryInfo.galleryId
      };
      this.setFullscreenElement();
    }
  }

  // initGalleryInfo() {
  //   if (utils.isInAlbumsBuilder()) {
  //     this.builderInitInterval && clearInterval(this.builderInitInterval);
  //     this.builderInitInterval = setInterval(() => {
  //       const worker = utils.getWorkerWindow();
  //       const compId = worker['pro-gallery-fullscreen-comp-id'];
  //       this.galleryData = worker['pro-gallery-data-' + compId] || {};
  //       if (this.galleryData.info) {
  //         //if the galleryWindow exist (fullscreen was open via click on item in gallery - use it to get the data
  //         this.galleryInfo = this.galleryData.info;
  //       }
  //     }, 2000);
  //   }
  //   return this.initGalleryInfoImp();
  // }
  ;
  _proto.initGalleryInfo = function initGalleryInfo() {
    var _this6 = this;
    var worker = utils.getWorkerWindow();
    var compId = worker['pro-gallery-fullscreen-comp-id'];
    if (compId === 'null') {
      compId = false;
    }
    this.navigatedBetweenSlides = false;
    try {
      if (utils.isInWix()) {
        // this.galleryWindow = window.parent.document.getElementById(this.galleryInfo.compId).getElementsByTagName('iframe')[0].contentWindow;
        this.galleryWindow = utils.getGalleryByCompId(compId) || window; // using || window is for cases where the fullscreen is loaded without a gallery (e.g. direct link)
        this.galleryData = worker['pro-gallery-data-' + compId] || {};
      } else {
        this.galleryData = window['pro-gallery-data-' + compId] || {};
        this.galleryWindow = window;
      }
    } catch (e) {
      this.galleryData = {};
      this.galleryWindow = window;
    }
    if (this.galleryData.info) {
      // if the galleryWindow exist (fullscreen was open via click on item in gallery - use it to get the data
      this.galleryInfo = this.galleryData.info;
      this.navigatedInto = true;
    } else if (utils.isInWix()) {
      // if the galleryWindow does not exist (fullscreen was open via direct URL)
      var watermarkData = null;
      var connectedProviders = null;
      if (utils.isStoreGallery()) {
        connectedProviders = window.connectedProviders;
      }
      this.galleryInfo = {
        compId: compId || utils.parsePathParam('comp-') || utils.parseGetParam('c') || utils.parseHashParam('c') || '',
        pageId: utils.parseGetParam('p') || utils.parseHashParam('p') || '',
        styleId: utils.parseGetParam('s') || utils.parseHashParam('s') || '',
        hashtag: utils.parseGetParam('ht') || utils.parseHashParam('ht') || '',
        reachLevel: utils.parseGetParam('rl') || utils.parseHashParam('rl') || 0,
        dateCreated: utils.getDateCreatedTicksFromStr(window.dateCreated),
        galleryId: window.galleryId,
        watermarkData: watermarkData,
        connectedProviders: connectedProviders
      };
    } else {
      this.galleryInfo = {
        compId: 'none',
        pageId: 'none',
        styleId: 'none',
        hashtag: 'none',
        galleryId: 'none',
        reachLevel: 0,
        watermarkData: {},
        connectedProviders: {}
      };
    }

    // use the compId to find the gallery window
    Wix.Utils.getSectionUrl({
      sectionId: utils.getFullscreenSectionId()
    }, function (res) {
      _this6.fullscreenUrl = res.url;
      _this6.itemActions.initWidgetData({
        compId: _this6.galleryInfo.compId,
        pageId: _this6.galleryInfo.pageId,
        styleId: _this6.galleryInfo.styleId,
        galleryId: _this6.galleryInfo.galleryId,
        fullscreenUrl: _this6.fullscreenUrl,
        onLoveCountsFetched: _this6.onLoveCountsFetched,
        viewMode: _this6.getViewMode()
      });
      _this6.itemActions.setReachLevel(_this6.galleryInfo.reachLevel);
    });
    Wix.getSitePages(function (pages) {
      var page = _.find(pages, {
        title: 'Fullscreen Page'
      });
      _this6.pageId = page && page.id || '';
    });
  };
  _proto.initNavigationEvents = function initNavigationEvents() {
    var _this7 = this;
    if (utils.isVerbose()) {
      console.log('FULLSCREEN - initNavigationEvents (start)');
    }
    if (utils.isInWix()) {
      if (utils.isVerbose()) {
        console.log('FULLSCREEN - initNavigationEvents (isInWix)');
      }
      if (!utils.isSite()) {
        if (utils.isVerbose()) {
          console.log('FULLSCREEN - initNavigationEvents (!isSite)');
        }
        window.addEventListener('message', function (e) {
          if (e.data.type === Wix.Events.STYLE_PARAMS_CHANGE) {
            _this7.onNewStyleParams(e.data.payload);
          }
        });
        Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, function () {
          _this7.setState({
            viewMode: utils.updateViewMode()
          });

          // fullscreen should always be closed in editor mode
          if (utils.isEditor()) {
            _this7.closeFullscreen();
          }
          Wix.getCurrentPageId(function (pageId) {
            if (_this7.navigatedInto || _this7.pageId === pageId) {
              _this7.closeFullscreen();
            }
          });
        });
      }
      Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_IN, function (data) {
        if (utils.isVerbose()) {
          console.log('FULLSCREEN - PAGE_NAVIGATION_IN', data);
        }
        if (data && data.isAppOnPage) {
          if (data.fromPage && data.toPage && data.fromPage === data.toPage) {
            return false;
          }
          _this7.navigatedInto = true;
          Wix.getCurrentPageId(function (pageId) {
            _this7.pageId = pageId;
          });
          _this7.init();
          try {
            window.parent.parent.postMessage({
              type: 'proGalleryFullscreen',
              payload: 'open'
            }, '*'); // for albums
          } catch (e) {
            return false;
          }
        }
      });
      Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_OUT, function (data) {
        if (utils.isVerbose()) {
          console.log('FULLSCREEN - PAGE_NAVIGATION_OUT', data);
        }
        if (data && data.wasAppOnPage) {
          if (data.fromPage && data.toPage && data.fromPage === data.toPage) {
            return false;
          }
          try {
            window.parent.parent.postMessage({
              type: 'proGalleryFullscreen',
              payload: 'close'
            }, '*'); // for albums
          } catch (e) {
            return false;
          }
          _this7.prepareToClose();
          if (_.isFunction(_this7.props.closeFullscreenCallback)) {
            _this7.props.closeFullscreenCallback(_this7.state.current.idx);
          } else if (_this7.galleryWindow) {
            _this7.galleryWindow.dispatchEvent(_this7.fullscreenClosedEvent);
          }
          utils.setStateAndLog(_this7, 'PAGE_NAVIGATION_OUT', {
            isFullscreenInView: false
          });
        }
      });
    } else {
      // close fullscreen on back button
      window.onpopstate = function () {
        return _this7.closeFullscreen();
      };
    }
  };
  _proto.initEvents = function initEvents() {
    this.fullscreenClosedEvent = window.document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
    this.fullscreenClosedEvent.initCustomEvent('fullscreen_closed', false, false, null);
    this.debouncedResizeEvent = _.debounce(this.resize, 100);
    window.addEventListener('resize', this.debouncedResizeEvent);
    window.addEventListener('orientationchange', this.orientationChange);
  };
  _proto.clearEvents = function clearEvents() {
    window.removeEventListener('resize', this.debouncedResizeEvent);
    window.removeEventListener('orientationchange', this.orientationChange);
  };
  _proto.initWatermark = function initWatermark() {
    var prerenderedItem = window.prerenderedItem;
    if (utils.isStoreGallery()) {
      var galleryInfo = this.galleryInfo || {};
      var watermarkData = galleryInfo.watermarkData;
      if (watermarkData) {
        this.setState({
          watermarkReady: true,
          watermark: watermarkData
        }, function () {});
      } else if (prerenderedItem && prerenderedItem.gallerySettings) {
        var gallerySettings = null;
        if (prerenderedItem.gallerySettings && typeof prerenderedItem.gallerySettings === typeof '') {
          try {
            var normalizedString = utils.stripSlashes(prerenderedItem.gallerySettings);
            gallerySettings = JSON.parse(normalizedString);
          } catch (error) {
            gallerySettings = {
              watermark: watermarkApi.defaultWatermarkData
            };
          }
        }
        this.setState({
          watermarkReady: true,
          watermark: gallerySettings.watermark
        });
      }
    }
  };
  _proto.cancelOpenHttpRequests = function cancelOpenHttpRequests() {
    // this hack clears up any pending socket issues. damn it chrome.
    // be careful - it cancels any http requests
    console.warn('Open fullscreen - canceling all http requests!');
    if (window && typeof window.stop === 'function') {
      window.stop();
    } else if (document.execCommand !== undefined) {
      window.document.execCommand('Stop', false);
    }
  };
  _proto.prepareInitialState = function prepareInitialState() {
    var initialItems = this.getInitialItems();
    var initialIdx = Math.min(this.getInitialItemIdx(), initialItems.length - 1);
    return {
      gotAllItems: false,
      isFullscreenInView: true,
      gotStyleParams: false,
      watermarkReady: !utils.isStoreGallery(),
      items: initialItems,
      swipperReady: false,
      showShare: false,
      viewMode: Wix.Utils.getViewMode(),
      cartItems: [],
      cartItemsCount: 0,
      isPlaying: false,
      isVideoLoading: false,
      initialIdx: initialIdx,
      activeIndex: initialIdx,
      styleParams: this.styleParams,
      watermark: watermarkApi.defaultWatermarkData,
      itemsLoveData: {}
    };
  }

  // ----------------------------------------| UTILS |----------------------------------------//
  ;
  _proto.parseStyleParams = function parseStyleParams(styles, isStoreGallery, isMobile) {
    return _extends({}, _parseStyleParams(styles, isStoreGallery, isMobile), this.galleryInfo && this.galleryInfo.styles);
  };
  _proto.getWatermark = function getWatermark() {
    if (this.state && this.state.watermark) {
      return this.state.watermark;
    } else if (this.galleryInfo && this.galleryInfo.watermarkData) {
      return this.galleryInfo.watermarkData;
    } else {
      return watermarkApi.defaultWatermarkData;
    }
  };
  _proto.getStaticMediaUrls = function getStaticMediaUrls() {
    return this.props.staticMediaUrls;
  };
  _proto.isPreload = function isPreload() {
    if (this.prerenderedItem) {
      // direct landing on fullscreen
      return false;
    }
    if (this.navigatedInto) {
      // click from gallery
      return false;
    }
    return true;

    // return !(this.galleryInfo && this.galleryInfo.compId && this.galleryInfo.pageId && this.galleryInfo.styleId);
  }

  // ------------------------------------| ITEMS MANAGER |------------------------------------//
  ;
  _proto.setCurrentItem = function setCurrentItem(idx) {
    var _this8 = this;
    var currentItemState = this.getCurrentItemState(idx);
    utils.setStateAndLog(this, 'setCurrentItem', {
      current: currentItemState
    }, function () {
      _this8.replaceCurrentUrl();
    });
  };
  _proto.createItem = function createItem(itemDto, idx, staticMediaUrls) {
    if (itemDto.dto) {
      // the item is already an object
      return itemDto;
    }
    return new GalleryItem({
      idx: idx,
      dto: itemDto.dto || itemDto,
      cubeImages: false,
      createdBy: 'fullscreenCreateItem',
      createMediaUrl: getResizeMediaUrl({
        staticMediaUrls: this.getStaticMediaUrls(),
        imageToken: this.getWatermark()
      })
    });
  };
  _proto.getInitialItemIdx = function getInitialItemIdx() {
    try {
      return Number(this.galleryInfo.itemIdx || utils.parseGetParam('i') || utils.parseHashParam('i') || this.props.demoModeParams.item || 0);
    } catch (e) {
      return 0;
    }
  };
  _proto.getInitialItems = function getInitialItems() {
    var _this9 = this;
    if (utils.isDev()) {
      console.time('Fullscreen Class - PREPARE ITEMS');
    }
    var items;
    var prerenderedItem = window.prerenderedItem;
    if (this.galleryData && this.galleryData.items) {
      try {
        this.galleryStructure = this.galleryData.items.galleryStructure;
        this.totalItemsCount = this.galleryData.items.totalItemsCount;
        this.currentGalleryItems = this.galleryData.items.currentGalleryItems;
        if (!prerenderedItem && this.galleryData.items.prerenderedItem) {
          prerenderedItem = this.galleryData.items.prerenderedItem;
        }
      } catch (e) {
        console.warn('Could not find galleryWindow items', e);
        this.totalItemsCount = 1;
      }
    } else {
      this.totalItemsCount = 1;
    }
    if (this.currentGalleryItems && this.galleryStructure) {
      // Opened from the Gallery -> get the items from the gallery window

      items = _.cloneDeep(this.currentGalleryItems);
      this.galleryItems = {};
      _.flattenDeep(this.galleryStructure.columns.map(function (column) {
        return (column.galleryGroups || column.groups || column).map(function (group) {
          return group.items;
        });
      })).forEach(function (item) {
        _this9.galleryItems[item.photoId] = item;
      });
      for (var i = 0; items[i]; i++) {
        items[i] = this.createItem(items[i], i);
      }
    } else if (prerenderedItem && prerenderedItem.items) {
      // Opened directly via deep link -> get the first item from the prerendered gallery

      items = prerenderedItem.items;
      this.prerenderedItem = new GalleryItem({
        dto: items[0],
        createdBy: 'fullscreenGetInitialItems',
        createMediaUrl: getResizeMediaUrl({
          staticMediaUrls: this.getStaticMediaUrls(),
          imageToken: this.getWatermark()
        })
      });
      this.totalItemsCount = 1; // keep count at 1 until more items arrive

      // use the infinite scroll url to get all the items up to this one
      this.prerenderedItems = [];
      this.completeMissingItems();
    } else if (window.emptyImages) {
      // Not opened yet (preload) or some sort of error -> get the sample images

      items = utils.isDev() ? window.sampleImages.photos : window.emptyImages.photos;
      this.totalItemsCount = items.length;
      if (!this.isPreload()) {
        // displaying the sample images is just as placeholders - the fullscreen should be closed
        if (utils.isDev()) {
          console.log('Closing fullscreen automatically (emptyImages are displayed while not in preload)');
        }
        this.closeFullscreen();
        // check if the fullscreen is the current page viewed and it displays empty (gray) images - if it is, close it
      } else if (!utils.isDev()) {
        Wix.getSiteInfo(function (siteInfo) {
          if (siteInfo && siteInfo.url && siteInfo.url.indexOf('fullscreen-page') > 0) {
            if (utils.isDev()) {
              console.log('Closing fullscreen automatically (emptyImages are displayed while page is displayed)');
            }
            _this9.closeFullscreen();
          }
        });
      }
    } else {
      items = [];
      this.totalItemsCount = 0;
      console.warn('No images to display on fullscreen');
    }
    if (utils.isDev()) {
      console.timeEnd('Fullscreen Class - PREPARE ITEMS');
    }
    return items;
  };
  _proto.closeFullscreen = function closeFullscreen() {
    this.prepareToClose();
    if (utils.isInWix()) {
      if (this.navigatedInto && this.styleParams.itemClick === 'popup') {
        Wix.closeWindow();
      } else if (this.galleryInfo.pageId) {
        Wix.navigateToPage(this.galleryInfo.pageId, {
          noTransition: true
        });
      } else if (this.galleryInfo.compId) {
        // todo maybe can remove this after seo links are updated with pageId
        var pageId = utils.getGallerySettingsFromWindow().pageId;
        if (pageId) {
          Wix.navigateToComponent(this.galleryInfo.compId, {
            pageId: pageId
          });
        }
      } else if (!this.isPreload()) {
        Wix.getSitePages(function (pages) {
          var homePage = _.find(pages, {
            isHomepage: true
          });
          if (homePage) {
            Wix.navigateToPage(homePage.id, {
              noTransition: true
            });
          }
        });
      }
    } else {
      utils.removeItemHashParam(window.location.href);
      // ReactDOM.unmountComponentAtNode(document.getElementById('gallery-fullscreen'));
      $('#gallery-fullscreen').hide();
      $('#content').show();
    }
  };
  _proto.completeMissingItems = function completeMissingItems() {
    var _this10 = this;
    if (this.gettingMoreItems) {
      return;
    }
    this.gettingMoreItems = true;
    if (this.galleryInfo.hashtag) {
      // get items by hashtag
      httpClient.get(utils.getApiUrlPrefix() + "gallery/" + window.galleryId + "/hashtags/" + this.galleryInfo.hashtag + "/items?instance=" + window.instance).then(function (_ref2) {
        var data = _ref2.data;
        _this10.gettingMoreItems = false;
        if (data && data.items && data.items.length > 0) {
          _this10.totalItemsCount = data.items.length;
          _this10.prerenderedItems = data.items;
          utils.setStateAndLog(_this10, 'completeMissingItems #1', {
            items: _this10.prerenderedItems,
            gotAllItems: false
          }, function () {
            _this10.replaceCurrentUrl(0, _this10.state.items[0]);
            utils.setStateAndLog(_this10, 'completeMissingItems #2', {
              gotAllItems: true,
              isPlaying: false
            });
          });
        }
      });
    } else {
      var infiniteScrollUrl = window.infiniteScrollUrl || this.galleryData && this.galleryData.window && this.galleryData.window.infiniteScrollUrl;
      var instance = window.instance || this.galleryData && this.galleryData.window && this.galleryData.window.instance;
      if (infiniteScrollUrl && instance) {
        // get items from gallery
        var batchSize = 100;
        httpClient.get(this.getItemsRangeUrl(this.prerenderedItems.length, this.prerenderedItems.length + batchSize)).then(function (_ref3) {
          var data = _ref3.data;
          // APIREFACTOR need to change? not used anymore!...
          _this10.gettingMoreItems = false;
          if (data && data.items && data.items.length > 0) {
            _this10.totalItemsCount = _this10.prerenderedItems.length + data.items.length;
            _this10.prerenderedItems = [].concat(_this10.prerenderedItems, data.items);
            var requiredItemIdx = _.findIndex(_this10.prerenderedItems, function (item) {
              return item.itemId === _this10.prerenderedItem.itemId;
            });
            if (requiredItemIdx >= 0 && requiredItemIdx < _this10.prerenderedItems.length) {
              // search for the item index
              console.log('The Item was found', requiredItemIdx);
              _this10.totalItemsCount = data.totalItemsCount; // now use the real total
              utils.setStateAndLog(_this10, 'completeMissingItems #1', {
                items: _this10.prerenderedItems,
                initialIdx: requiredItemIdx,
                gotAllItems: false
              }, function () {
                _this10.replaceCurrentUrl();
                utils.setStateAndLog(_this10, 'completeMissingItems #2', {
                  gotAllItems: true,
                  isPlaying: false
                });
              });
            } else {
              console.warn('The Item was not found! - retrying...');
              _this10.completeMissingItems();
            }
          }
        })["catch"](function (e) {
          _this10.gettingMoreItems = false;
          console.error('cannot complete Missing Items ', e);
        });
      } else {
        if (!infiniteScrollUrl) {
          console.warn('Could not get more items - missing infinite scroll url');
        }
        if (!instance) {
          console.warn('Could not get more items - missing instance');
        }
      }
    }
  };
  _proto.getItemsRangeUrl = function getItemsRangeUrl(from, to) {
    var dataContainer = this.galleryData.window || window;
    var infiniteScrollUrl = dataContainer.infiniteScrollUrl,
      instance = dataContainer.instance;
    var isStoreGallery = utils.isStoreGallery();
    var infiniteScrollUrlWithoutHttpOrHttps = infiniteScrollUrl.replace(/(^\w+:|^)\/\//, '//');
    if (isStoreGallery) {
      infiniteScrollUrlWithoutHttpOrHttps = infiniteScrollUrlWithoutHttpOrHttps.replace('progallery.wix.com', 'progallery.wixapps.net');
    }
    var storeParameter = isStoreGallery ? '&isStore=true' : '';
    return infiniteScrollUrlWithoutHttpOrHttps + "from/" + from + "/to/" + to + "?instance=" + instance + storeParameter;
  };
  _proto.getMoreItems = /*#__PURE__*/function () {
    var _getMoreItems = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(from) {
      var _this11 = this;
      var response, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!this.fetchingMoreItems && !_.isUndefined(from))) {
              _context.next = 8;
              break;
            }
            this.fetchingMoreItems = true;
            _context.next = 4;
            return httpClient.get(this.getItemsRangeUrl(from, from + 100));
          case 4:
            response = _context.sent;
            data = response.data;
            this.fetchingMoreItems = false;
            if (data && data.items && data.items.length > 0) {
              this.totalItemsCount = data.totalItemsCount;
              utils.setStateAndLog(this, 'getMoreItems', {
                items: this.state.items.concat(data.items),
                gotAllItems: false
              }, function () {
                utils.setStateAndLog(_this11, 'complete getMoreItems', {
                  gotAllItems: true
                });
              });
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function getMoreItems(_x) {
      return _getMoreItems.apply(this, arguments);
    }
    return getMoreItems;
  }();
  _proto.updateLocalLoveData = function updateLocalLoveData(id) {
    var _extends2;
    var itemsLoveData = this.state.itemsLoveData;
    var updatedItemLoveData;
    if (itemsLoveData[id]) {
      updatedItemLoveData = {
        isLoved: !itemsLoveData[id].isLoved,
        loveCount: itemsLoveData[id].isLoved ? itemsLoveData[id].loveCount - 1 : itemsLoveData[id].loveCount + 1
      };
    } else {
      updatedItemLoveData = {
        isLoved: true,
        loveCount: 1
      };
    }
    var updatedItemsLoveData = _extends({}, itemsLoveData, (_extends2 = {}, _extends2[id] = updatedItemLoveData, _extends2));
    this.setState({
      itemsLoveData: updatedItemsLoveData
    });
  }

  // ---------------------------------------| STYLES |----------------------------------------//
  ;
  _proto.onNewStyleParams = function onNewStyleParams(wixStyles) {
    var wixStylesParsed = _.merge({}, wixStyles.numbers, wixStyles.booleans, wixStyles.colors, wixStyles.fonts, wixStyles.manual);

    // Update according to new styles
    // (due to quality / usm params change)
    utils.setStateAndLog(this, 'onNewStyleParams', {
      styleParams: this.parseStyleParams(wixStylesParsed, utils.isStoreGallery()),
      gotStyleParams: true
    });
  };
  _proto.getStyleParams = function getStyleParams() {
    var _this12 = this;
    var wixStyles = {};
    if (utils.isInWix()) {
      if (this.galleryInfo.styleId) {
        Wix.Styles.getStyleParamsByStyleId(this.galleryInfo.styleId, {
          pageId: this.galleryInfo.pageId
        }, function (sp) {
          _this12.onNewStyleParams(_extends({}, sp, {
            manual: _extends({}, _this12.galleryInfo.styles)
          }));
        }, function (e) {
          _this12.onNewStyleParams({});
          console.error('Style id not found - ', _this12.galleryInfo.styleId, e);
        });
      } else {
        this.onNewStyleParams({});
      }
    } else if (typeof window.styles === 'object') {
      wixStyles = window.styles;
      this.onNewStyleParams(wixStyles);
    } else if (utils.parseGetParam('galleryStyle')) {
      var galleryStyle = utils.parseGetParam('galleryStyle');
      if (/^[\],:{}\s]*$/.test(galleryStyle.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        // the json is ok
        wixStyles = JSON.parse(galleryStyle);
        this.onNewStyleParams(wixStyles);
      }
    } else {
      this.onNewStyleParams({});
    }
  }

  // --------------------------------------| BEHAVIOUR |--------------------------------------//
  ;
  _proto.orientationChange = function orientationChange() {
    utils.fixViewport('Fullscreen - oriantation change');
    this.resize();
  };
  _proto.prepareToClose = function prepareToClose() {
    if (!this.isOpen) {
      return;
    }
    this.isOpen = false;
    this.clearEvents();
    this.navigatedInto = false;
    utils.setStateAndLog(this, 'closeFullscreen', {
      isFullscreenInView: false
    });

    // save current items to the window
    try {
      var worker = utils.getWorkerWindow();
      if (worker) {
        worker['pro-gallery-data-' + this.galleryInfo.compId].fullscreenData = {
          currentGalleryItems: this.state.items,
          currentGalleryItemIdx: this.state.activeIndex,
          currentHashtag: this.galleryInfo.hashtag
        };
        worker['pro-gallery-hashtag-filter'] = this.galleryInfo.hashtag;
      }
    } catch (e) {
      //
    }
  };
  _proto.replaceCurrentUrl = function replaceCurrentUrl(idx, item) {
    if (!utils.isInWix()) {
      return;
    }
    if (this.isPreload()) {
      return;
    }
    if (this.totalItemsCount <= 1) {
      return;
    } // when there is only one item (landing on the fullscreen) - do not change the url

    if (_.isUndefined(idx)) {
      idx = this.state.initialIdx;
    }
    if (_.isUndefined(item)) {
      item = this.state.items[this.state.initialIdx];
    }
    var justNavigatedFromGallery = !this.navigatedBetweenSlides;
    if (justNavigatedFromGallery) {
      // Removed because of WixCode fullscreen issue (fullscreen gets 502 after navigation)
      // return;
    }
    var newUrl = utils.getFullscreenUrlState(this.galleryInfo.compId, item.itemId, idx, this.galleryInfo.pageId, this.galleryInfo.styleId);
    if (!utils.isEditor()) {
      Wix.replaceSectionState(newUrl);
    }
  };
  _proto.resize = function resize() {
    utils.setStateAndLog(this, 'resize', {
      container: {
        width: utils.getWindowWidth(),
        height: utils.getWindowHeight()
      }
    });
  }

  // ---------------------------------------| HANDLE EVENTS |---------------------------------------//
  ;
  _proto.handleFullscreenEvent = function handleFullscreenEvent(eventName, eventData) {
    switch (eventName) {
      case FULLSCREEN_EVENTS.CLOSE_FULLSCREEN:
        this.closeFullscreen();
        break;
      case FULLSCREEN_EVENTS.NEED_MORE_ITEMS:
        this.getMoreItems(eventData);
        break;
      case FULLSCREEN_EVENTS.TOGGLE_BROWSER_FULLSCREEN:
        this.expandBrowser();
        break;
      case FULLSCREEN_EVENTS.NAVIGATE:
        this.navigate(eventData);
        break;
      case FULLSCREEN_EVENTS.ON_NEXT_SLIDE:
        this.onNextSlide(eventData);
        break;
      case FULLSCREEN_EVENTS.ITEM_CREATED:
        this.onItemCreated();
        break;
      case FULLSCREEN_EVENTS.SHARE_BUTTON_CLICKED:
        if (utils.isSite()) {
          this.handleItemActions('share', eventData);
        }
        break;
      case FULLSCREEN_EVENTS.TEXT_DOWNLOAD_BUTTON_CLICKED:
        if (utils.isSite()) {
          this.handleItemActions('downloadTextItem', eventData);
          this.reportBiEvent('downloadTextItem', eventData);
        }
        break;
      case FULLSCREEN_EVENTS.DOWNLOAD_BUTTON_CLICKED:
        if (utils.isSite()) {
          this.reportBiEvent('onDownloadButtonClicked', eventData);
        }
        break;
      case FULLSCREEN_EVENTS.LOVE_BUTTON_CLICKED:
        if (utils.isSite()) {
          this.updateLocalLoveData(eventData.id);
          this.handleItemActions('toggleLove', eventData);
          this.handleItemActions('postLoveActivity', eventData);
        }
        break;
      default:
        if (utils.isVerbose()) {
          console.log(eventName, 'is not handled in handleEvent function');
        }
    }
  };
  _proto.reportBiEvent = function reportBiEvent(eventName, eventData) {
    switch (eventName) {
      case 'onDownloadButtonClicked':
      case 'downloadTextItem':
        logger.log('download', {
          origin: 'fullscreen'
        });
        break;
      case 'onBuyNowClicked':
        logger.log('buyBuyNowClick');
        break;
    }
  };
  _proto.handleItemActions = function handleItemActions(action, actionData) {
    var item;
    switch (action) {
      case 'share':
        this.itemActions.share(actionData.network, actionData.shareProps, 'fullscreen');
        break;
      case 'showTooltip':
        this.itemActions.showTooltip(actionData.event, actionData.key);
        break;
      case 'hideTooltip':
        this.itemActions.hideTooltip();
        break;
      case 'downloadTextItem':
        item = {
          html: actionData.html,
          style: actionData.style
        };
        this.itemActions.downloadTextItem(item, 'fullscreen');
        break;
      case 'postLoveActivity':
        item = {
          type: actionData.type,
          itemId: actionData.itemId,
          id: actionData.id,
          idx: actionData.idx,
          hashtag: actionData.hashtag
        };
        this.itemActions.postLoveActivity(item);
        break;
      case 'toggleLove':
        this.itemActions.toggleLove(actionData.id, actionData.layout);
        break;
    }
  };
  _proto.onItemCreated = function onItemCreated() {
    if (!window.appLoaded) {
      this.reportAppLoaded();
    }
    if (!window.appLoadedOLD) {
      this.reportAppLoadedOLD();
    }
  };
  _proto.reportAppLoadedOLD = function reportAppLoadedOLD() {
    if (utils.isTest() || !window) {
      // report AppLoaded via old report (via performanceUtils)
      return;
    }
    if (!window.appLoadedOLD) {
      window.appLoadedOLD = true;
      try {
        if (Wix && Wix.Performance && typeof Wix.Performance.applicationLoaded === 'function') {
          Wix.Performance.applicationLoaded();
        }
      } catch (e) {
        // console.log('fedopsLogger: apploaded failed ', appName, e);
      }
    }
  };
  _proto.reportAppLoaded = function reportAppLoaded() {
    if (utils.isTest() || !window || !window.prerenderedItem) {
      // reportAppLoaded only if it's fullscreen landing link (iFrame)
      return;
    }
    if (!window.appLoaded) {
      // not supposed to be called if window.appLoaded is true, but just in case.
      window.appLoaded = true;
      if (window.fedopsAppName) {
        try {
          console.log(window.fedopsAppName, 'loaded');
          // window.fedopsAppName='pro-gallery-fullscreen-landing'
          var _fedopsLogger = fedopsLogger.create(window.fedopsAppName);
          if (_fedopsLogger) {
            _fedopsLogger.appLoaded();
          }
        } catch (e) {
          // console.log('fedopsLogger: apploaded failed ', appName, e);
        }
      }
    }
  }

  // ---------------------------------------| RENDER |---------------------------------------//
  ;
  _proto.readyToRender = function readyToRender() {
    var _this13 = this;
    if (!this.state.gotStyleParams) {
      if (utils.isVerbose()) {
        console.warn('FULLSCREEN RENDER - Not rendering Fullscreen - no style params', !utils.isTest() && this.state);
      }
      return false;
    }
    if (!this.state.isFullscreenInView) {
      if (utils.isVerbose()) {
        console.warn('FULLSCREEN RENDER - Not rendering Fullscreen - fullscreen not in view', !utils.isTest() && this.state);
      }
      return false;
    }
    if (!this.state.gotAllItems && !this.gettingMoreItems && this.state.items.length >= 1) {
      if (utils.isVerbose()) {
        console.warn('FULLSCREEN RENDER - Not rendering Fullscreen - wating for more items', !utils.isTest() && this.state);
      }
      return false;
    }
    if (!this.state.watermarkReady) {
      if (utils.isVerbose()) {
        console.warn('FULLSCREEN RENDER - Not rendering Fullscreen - watermark not ready', !utils.isTest() && this.state);
      }
      return false;
    }
    if (utils.isVerbose()) {
      _.once(function () {
        return console.warn('FULLSCREEN RENDER - Rendering Fullscreen', !utils.isTest() && _this13.state);
      });
    }
    return true;
  };
  _proto.navigate = function navigate(linkData) {
    if (linkData.linkType === 'wix') {
      Wix.navigateTo(linkData.linkData);
    } else {
      Wix.navigateToPage(linkData.linkUrl, {
        noTransition: true
      });
    }
  };
  _proto.isBrowserExpanded = function isBrowserExpanded() {
    return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
  };
  _proto.expandBrowser = function expandBrowser() {
    if (!this.isBrowserExpanded()) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  };
  _proto.onNextSlide = function onNextSlide(itemIdx) {
    if (itemIdx && !_.isUndefined(this.state.items[itemIdx])) {
      this.setState({
        activeIndex: itemIdx
      });
      this.replaceCurrentUrl(itemIdx, this.state.items[itemIdx]);
    }
  };
  _proto.getViewMode = function getViewMode() {
    var viewMode = '';
    if (window && window.Wix && window.Wix.Utils && window.Wix.Utils.getViewMode) {
      viewMode = window.Wix.Utils.getViewMode();
    }
    switch (viewMode.toLowerCase()) {
      case 'editor':
        return VIEW_MODE.EDIT;
      case 'preview':
        return VIEW_MODE.PREVIEW;
      case 'site':
      default:
        return VIEW_MODE.SITE;
    }
  };
  _proto.render = function render() {
    if (!this.readyToRender()) {
      return null;
    }
    this.initFullscreenElementIfNeeded();
    var watermark = utils.isStoreGallery() ? this.state.watermark : false;
    var Fullscreen = this.fullscreenElement;
    return /*#__PURE__*/React.createElement(Fullscreen, {
      items: this.state.items,
      totalItemsCount: this.totalItemsCount,
      styles: this.state.styleParams,
      initialIdx: this.state.initialIdx,
      galleryInfo: this.galleryInfo,
      container: this.state.container,
      locale: Wix.Utils.getLocale(),
      deviceType: Wix.Utils.getDeviceType(),
      isPreview: !utils.isSite(),
      watermark: watermark,
      viewMode: this.getViewMode(),
      cartItems: this.state.cartItems,
      cartItemsCount: this.state.cartItemsCount,
      eventsListener: this.handleFullscreenEvent,
      itemsLoveData: this.state.itemsLoveData,
      shouldUseNewSocialSharePopup: this.shouldUseNewSocialSharePopup
    });
  };
  return ProFullscreenTPAWrapper;
}(Component);
export default ProFullscreenTPAWrapper;